import { useEffect, useState } from "react";
import { Lock, Sparkles } from "lucide-react";
import api from "../lib/apiClient";

// Verrou proactif réutilisable : si l'entitlement n'est pas accordé par le backend
// (source de vérité), affiche un upsell et déclenche la modale d'upgrade partagée.
// En FREE_MODE (preview) tout est accordé → rend les enfants normalement.
export function FeatureLock({ entitlement, feature, requiredPlan, children }) {
  const [state, setState] = useState("loading"); // loading | allowed | locked

  useEffect(() => {
    api.get("/subscription")
      .then((r) => {
        const ents = r.data?.entitlements || {};
        setState(ents[entitlement] === false ? "locked" : "allowed");
      })
      .catch(() => setState("allowed"));
  }, [entitlement]);

  if (state === "loading") return null;
  if (state === "allowed") return children;

  const planName = requiredPlan === "PRO" ? "Pro" : "Premium";
  const trigger = () => window.dispatchEvent(new CustomEvent("cehnura:paywall", {
    detail: { upgrade_required: requiredPlan, feature, reason: `${feature} est disponible avec le plan ${planName}.` },
  }));

  return (
    <div className="max-w-lg mx-auto text-center py-16" data-testid={`feature-lock-${entitlement}`}>
      <div className="w-14 h-14 rounded-2xl bg-amber-500/10 border border-amber-500/30 flex items-center justify-center mx-auto mb-5">
        <Lock className="w-6 h-6 text-amber-400" />
      </div>
      <h2 className="font-display text-2xl font-extrabold mb-2">{feature}</h2>
      <p className="text-zinc-400 mb-6">Cette fonctionnalité est disponible avec le plan <span className="text-amber-400 font-semibold">{planName}</span>.</p>
      <button onClick={trigger} data-testid={`feature-lock-cta-${entitlement}`}
        className="h-12 px-7 rounded-xl gold-gradient text-black font-semibold inline-flex items-center gap-2 hover:opacity-90 transition-opacity">
        <Sparkles className="w-4 h-4" /> Débloquer avec {planName}
      </button>
    </div>
  );
}
